import { Button, Flex, Hide, Icon, Spacer, Text, useBreakpointValue as breakptValue } from '@chakra-ui/react'
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { RiFileExcel2Line } from "react-icons/ri";


export const ExcelButton = ({ data, fileName }) => {
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (data, fileName) => {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blobData = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blobData, fileName + fileExtension);
    };

    return (
        <Button leftIcon={breakptValue({base:null, md:<RiFileExcel2Line />})} onClick={(e) => exportToCSV(data, fileName)} colorScheme="green" size="sm">
            <Hide below='md'>Excel</Hide>
            <Hide above='md'><Icon as={RiFileExcel2Line} /></Hide>
        </Button>
    );
};

/* options {
    excel : {
        data : [],
        fileName: ''
    }
}

*/
const ExportToolsPanel = ({ options,children }) => {
    return (
        <Flex w="full" align="center">
            {children}
            <Spacer />
            <Hide below="md"><Text fontWeight="bold" mr={2}>นำข้อมูลออก</Text></Hide>
            {options?.excel && <ExcelButton {...options.excel} />}
        </Flex>
    )
}

export default ExportToolsPanel
